import React from 'react';
import { Mail, MessageCircle } from 'lucide-react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WhatsAppInbox from './WhatsAppInbox';
import EmailInbox from './EmailInbox';
export default function Inbox() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const email = pathname === '/inbox/email' || pathname.startsWith('/inbox/email/');
  if (!user?.whatsappInboxEnabled && !user?.emailInboxEnabled) return <Navigate to="/leads" replace />;
  if (!email && !user?.whatsappInboxEnabled) return <Navigate to="/inbox/email" replace />;
  if (email && !user?.emailInboxEnabled) return <Navigate to="/inbox" replace />;
  return <div className="inbox-workspace flex h-full min-h-0 flex-col gap-3">
    <div className={`inbox-channel-bar ${email && pathname.startsWith('/inbox/email/') ? 'email-reading-channels' : ''}`}>
      <div className="hidden sm:block"><p className="text-sm font-semibold text-gray-900">Customer conversations</p><p className="mt-0.5 text-xs text-gray-500">Your team’s shared inbox.</p></div>
      <nav aria-label="Inbox channels" className="inbox-channel-switch">
        {user?.whatsappInboxEnabled && <Link to="/inbox" aria-current={!email ? 'page' : undefined} className="inbox-channel"><MessageCircle aria-hidden="true" className="h-4 w-4" />WhatsApp</Link>}
        {user?.emailInboxEnabled && <Link to="/inbox/email" aria-current={email ? 'page' : undefined} className="inbox-channel"><Mail aria-hidden="true" className="h-4 w-4" />Email</Link>}
      </nav>
    </div>
    <div className="min-h-0 flex-1">{email ? <EmailInbox key={`${user?.workspaceOwnerId || user?.id}:${user?.id}`} /> : <WhatsAppInbox />}</div>
  </div>;
}
